import fetchServer from "../../fetchServer";

export default async function loginAdminTeam(data) {
  let result = {return: 0,msg: 'Something went wrong logging member!'}

  await fetchServer({method: 'POST',url: '/main/v1/adminTeam/login?populate=roles',data})
  .then((res) => {
    if(res.data && res?.data?.data) {
      result = {return: 1,msg: 'Welcome',data: res.data?.data}
    } else result['msg'] = res?.data?.error || result['msg']
  })
  .catch((err) => {
    console.log(err)
    result['msg'] = err.message
    console.log('Network Error!')
  })

  return result;
}